export const HOLD_ALLOCATION_BUCKETS = Object.freeze({
  ALL: 'ALL',
  RELEASABLE: 'RELEASABLE',
  READY_TO_ALLOCATE: 'READY_TO_ALLOCATE',
  LOCKED: 'LOCKED',
  // Orders with no active holds and no allocatable inventory.
  // The backend returns this bucket and its dashboard count, but
  // V2 listing does not render it as a selectable bucket card.
  // The constant exists so code paths that compare against bucket
  // strings do not break when the API emits this value.
  AWAITING_STOCK: 'AWAITING_STOCK',
})

export const MOCK_ROLES = Object.freeze([
  { value: 'CUSTOMER_SERVICE', label: 'Customer Service' },
  { value: 'FINANCE', label: 'Finance' },
  { value: 'QUALITY', label: 'Quality' },
  { value: 'OPERATIONS', label: 'Operations' },
])

export const HOLD_STATUS_LABELS = Object.freeze({
  ON_HOLD: 'On Hold',
  PARTIAL_HOLD: 'Partial Hold',
  NO_HOLD: 'No Hold',
  RELEASED: 'Released',
})

export const BUCKET_LABELS = Object.freeze({
  ALL: 'All Order',
  RELEASABLE: 'Releasable',
  READY_TO_ALLOCATE: 'Ready to Allocate',
  LOCKED: 'Locked',
})

export const BUCKET_COLORS = Object.freeze({
  ALL: '#145a4b',
  RELEASABLE: '#f5a623',
  READY_TO_ALLOCATE: '#2db47d',
  LOCKED: '#cc3f0c',
})

export const BUCKET_ICONS = Object.freeze({
  ALL: 'list',
  RELEASABLE: 'key',
  LOCKED: 'lock',
  READY_TO_ALLOCATE: 'rocket',
})

export const ALLOCATION_STATUS = Object.freeze({
  PENDING: 'PENDING',
  PARTIAL: 'PARTIAL',
  ALLOCATED: 'ALLOCATED',
  DEFERRED: 'DEFERRED',
})

// Search field options for the listing search dropdown
export const SEARCH_FIELDS = Object.freeze([
  { value: 'orderNo', label: 'Order No' },
  { value: 'poNumber', label: 'PO Number' },
  { value: 'shipTo', label: 'Ship-to Name' },
  { value: 'shipAccount', label: 'Ship-to A/C' },
])
